import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'vuidword'
})
export class ValidationUidWord implements PipeTransform {

  constructor() { }

  transform(value: string): string {
    // Min 2 letters
    value = !!value ? value.replace(new RegExp("[0-9]", "g"), "") : '';
    value = !!value ? value.replace(new RegExp("[!@#\$%\^\&*\)\(+=.,<>/?:;'\\\\\|\\{\\}\\[\\]\"`^_-\\s]", "g"), "") : '';
    if (value && value.match('^[a-zA-Z]{2,}$')) {
      return 'valid';
    }
    // Min 2 letters
   return 'invalid';
  }
}
